import { useQuery } from "@apollo/client";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import "../../App.css";
import { currencyFormat } from "../../Function/DynamicFn";
import { GET_MONTLY_INVENTORY_REPORT_III } from "../../Schema/Report";
import { EmptyTr } from "../Include/EmptyData";
import { LoadingTr } from "../Include/LoadingPage";

export default function ReportFirst({
  startDate,
  endDate,
  meterialId,
  sectionListId,
  levelSectionListId,
  groupId,
  sizeListId,
  warehouseValId,
  isHaveStock,
}) {
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(null);
  const [loading, setLoading] = useState(true);
  
  console.log("variables :", {
    from: startDate ? dayjs(startDate).format("YYYY-MM-DDTHH:mm:ss.SSS") : "",
    to: endDate ? dayjs(endDate).format("YYYY-MM-DDTHH:mm:ss.SSS") : "",
  });

  const { refetch } = useQuery(GET_MONTLY_INVENTORY_REPORT_III, {
    // useQuery(GET_MONTLY_INVENTORY_REPORT_III, {
    variables: {
      from: startDate ? dayjs(startDate).format("YYYY-MM-DDTHH:mm:ss.SSS") : "",
      to: endDate ? dayjs(endDate).format("YYYY-MM-DDTHH:mm:ss.SSS") : "",
      isHaveStock:
        isHaveStock === "all"
          ? null
          : isHaveStock === "haveStock"
            ? true
            : false,
      warehouseIds: warehouseValId ? [warehouseValId] : [],
      materialIds: meterialId ? meterialId : [],
      sectionIds: sectionListId ? sectionListId : [],
      sizeIds: sizeListId ? sizeListId : [],
      levelSectionIds: levelSectionListId ? levelSectionListId : [],
      groupIds: groupId ? groupId : [],
    },
    onCompleted: ({ getMonthlyInventoryReportIII }) => {
      setTableData(getMonthlyInventoryReportIII);
      if (getMonthlyInventoryReportIII?.length > 0) {
        const totals = getMonthlyInventoryReportIII.reduce(
          (acc, pre) => {
            acc.totalBeginningUnit += pre.beginning.units;
            acc.totalBeginningCost += pre.beginning.cost;
            acc.totalPurchaseUnit += pre.purchase.units;
            acc.totalPurchaseCost += pre.purchase.cost;
            acc.totalIssueUnit += pre.issues.units;
            acc.totalIssueCost += pre.issues.cost;
            acc.totalReturnUnit += pre.return.units;
            acc.totalReturnCost += pre.return.cost;
            acc.totalEndUnit += pre.ending.units;
            acc.totalEndCost += pre.ending.cost;
            return acc;
          },
          {
            totalBeginningUnit: 0,
            totalBeginningCost: 0,
            totalPurchaseUnit: 0,
            totalPurchaseCost: 0,
            totalIssueUnit: 0,
            totalIssueCost: 0,
            totalReturnUnit: 0,
            totalReturnCost: 0,
            totalEndUnit: 0,
            totalEndCost: 0,
          },
        );

        setTotal({
          totalBeginningUnit: totals.totalBeginningUnit.toFixed(2),
          totalBeginningCost: totals.totalBeginningCost.toFixed(2),
          totalPurchaseUnit: totals.totalPurchaseUnit.toFixed(2),
          totalPurchaseCost: totals.totalPurchaseCost.toFixed(2),
          totalIssueUnit: totals.totalIssueUnit.toFixed(2),
          totalIssueCost: totals.totalIssueCost.toFixed(2),
          totalReturnUnit: totals.totalReturnUnit.toFixed(2),
          totalReturnCost: totals.totalReturnCost.toFixed(2),
          totalEndUnit: totals.totalEndUnit.toFixed(2),
          totalEndCost: totals.totalEndCost.toFixed(2),
        });
      } else setTotal(null);

      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::getMonthlyInventoryReportIII", err?.message);
    },
  });

  useEffect(() => {
    setLoading(true);
    refetch();
  }, [
    startDate,
    endDate,
    groupId,
    meterialId,
    warehouseValId,
    sectionListId,
    levelSectionListId,
    isHaveStock,
    sizeListId,
  ]);

  return (
    <>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        marginTop="25px"
      >
        <Typography className="report-title-kh">
          សន្និធីប្រើប្រាស់ប្រចាំខែ
        </Typography>
        <Typography className="report-title-en">
          {`${moment(startDate)?.format("DD-MM-YYYY")} - ${moment(endDate)?.format("DD-MM-YYYY")}`}
        </Typography>
      </Stack>
      <div className="report-table-scroll-container">
        <table className="report-table">
          <tbody className="report-table-thead">
            <tr>
              <td className="report-table-th-sticky-en" rowSpan="2">
                No
              </td>
              <td className="report-table-th-sticky-en" rowSpan="2">
                Description
              </td>
              <td className="report-table-th-sticky-en" rowSpan="2">
                Unit
              </td>
              <td className="report-table-th-sticky-en" rowSpan="2">
                Size
              </td>
              <td className="report-table-th-sticky-en" colSpan="3">
                Beginning Inventory
              </td>
              <td className="report-table-th-sticky-en" colSpan="3">
                Purchase
              </td>

              <td rowSpan={2} className="report-table-th-sticky-en">
                Average Cost
              </td>

              <td className="report-table-th-sticky-en" colSpan="2">
                Return
              </td>

              <td className="report-table-th-sticky-en" colSpan="2">
                Issues
              </td>

              <td className="report-table-th-sticky-en" colSpan="2">
                Ending Balance
              </td>
            </tr>

            <tr>
              <td className="report-table-th-sticky-en">Cost Per Unit</td>
              <td className="report-table-th-sticky-en">Units</td>
              <td className="report-table-th-sticky-en">Cost</td>
              <td className="report-table-th-sticky-en">Cost per unit</td>
              <td className="report-table-th-sticky-en">Unit</td>
              <td className="report-table-th-sticky-en">Total Cost</td>
              <td className="report-table-th-sticky-en">Unit</td>
              <td className="report-table-th-sticky-en">Cost</td>
              <td className="report-table-th-sticky-en">Unit</td>
              <td className="report-table-th-sticky-en">Cost</td>
              <td className="report-table-th-sticky-en">Unit</td>
              <td className="report-table-th-sticky-en">Cost</td>
            </tr>
          </tbody>

          <tbody className="report-table-body">
            {loading ? (
              <LoadingTr colSpan={19} />
            ) : tableData?.length < 1 ? (
              <EmptyTr colSpan={19} />
            ) : (
              tableData?.map((e, index) => {
                return (
                  <Fragment key={index}>
                    <tr>
                      <td
                        className="report-table-sub-th-i"
                        colSpan="5"
                        style={{ textAlign: "left" }}
                      >
                        {e?.groupKhName}
                      </td>

                      <td className="report-table-sub-th-i" align="center">
                        <Typography className="head-text-cost-unit-bold">
                          {e?.beginning?.units}
                        </Typography>
                      </td>
                      <td className="report-table-sub-th-i">
                        <Stack direction="row" justifyContent="space-between">
                          <Typography className="head-text-cost-unit-bold">
                            $
                          </Typography>
                          <Typography className="head-text-cost-unit-bold">
                            {currencyFormat(e?.beginning?.cost?.toFixed(2))}
                          </Typography>
                        </Stack>
                      </td>

                      <td className="report-table-sub-th-i"></td>
                      <td className="report-table-sub-th-i" align="center">
                        <Typography className="head-text-cost-unit-bold">
                          {e?.purchase?.units}
                        </Typography>
                      </td>
                      <td className="report-table-sub-th-i">
                        <Stack direction="row" justifyContent="space-between">
                          <Typography className="head-text-cost-unit-bold">
                            $
                          </Typography>
                          <Typography className="head-text-cost-unit-bold">
                            {currencyFormat(e?.purchase?.cost?.toFixed(2))}
                          </Typography>
                        </Stack>
                      </td>
                      <td className="report-table-sub-th-i"></td>
                      <td className="report-table-sub-th-i" align="center">
                        <Typography className="head-text-cost-unit-bold">
                          {e?.return?.units}
                        </Typography>
                      </td>
                      <td className="report-table-sub-th-i">
                        <Stack direction="row" justifyContent="space-between">
                          <Typography className="head-text-cost-unit-bold">
                            $
                          </Typography>
                          <Typography className="head-text-cost-unit-bold">
                            {currencyFormat(e?.return?.cost?.toFixed(2))}
                          </Typography>
                        </Stack>
                      </td>

                      <td className="report-table-sub-th-i" align="center">
                        <Typography className="head-text-cost-unit-bold">
                          {e?.issues?.units}
                        </Typography>
                      </td>
                      <td className="report-table-sub-th-i">
                        <Stack direction="row" justifyContent="space-between">
                          <Typography className="head-text-cost-unit-bold">
                            $
                          </Typography>
                          <Typography className="head-text-cost-unit-bold">
                            {currencyFormat(e?.issues?.cost?.toFixed(2))}
                          </Typography>
                        </Stack>
                      </td>

                      <td className="report-table-sub-th-i" align="center">
                        <Typography className="head-text-cost-unit-bold">
                          {e?.ending?.units}
                        </Typography>
                      </td>
                      <td className="report-table-sub-th-i">
                        <Stack direction="row" justifyContent="space-between">
                          <Typography className="head-text-cost-unit-bold">
                            $
                          </Typography>
                          <Typography className="head-text-cost-unit-bold">
                            {currencyFormat(e?.ending?.cost?.toFixed(2))}
                          </Typography>
                        </Stack>
                      </td>
                    </tr>

                    {e?.materials?.map((row, subIndex) => {
                      return (
                        <tr key={subIndex}>
                          <td
                            className="table-book-body-field"
                            style={{ textAlign: "center" }}
                          >
                            {subIndex + 1}
                          </td>
                          <td className="table-book-body-field">
                            {row?.materialKhName}
                          </td>
                          <td
                            className="table-book-body-field"
                            style={{ textAlign: "center" }}
                          >
                            {row?.smallUnitId?.unitKhName}
                          </td>
                          <td
                            className="table-book-body-field"
                            style={{ textAlign: "center" }}
                          >
                            {row?.sizeId?.sizeKhName}
                          </td>

                          <td className="table-book-body-field">
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                            >
                              <Typography className="text-field-cost-unit">
                                $
                              </Typography>
                              <Typography className="text-field-cost-unit">
                                {row?.beginning?.costPerUnit > 0
                                  ? currencyFormat(
                                      row?.beginning?.costPerUnit?.toFixed(2),
                                    )
                                  : "-"}
                              </Typography>
                            </Stack>
                          </td>
                          <td
                            className="table-book-body-field"
                            style={{ textAlign: "center" }}
                          >
                            {row?.beginning?.units}
                          </td>
                          <td className="table-book-body-field">
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                            >
                              <Typography className="text-field-cost-unit">
                                $
                              </Typography>
                              <Typography className="text-field-cost-unit">
                                {row?.beginning?.cost > 0
                                  ? currencyFormat(
                                      row?.beginning?.cost?.toFixed(2),
                                    )
                                  : "-"}
                              </Typography>
                            </Stack>{" "}
                          </td>

                          <td className="table-book-body-field">
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                            >
                              <Typography className="text-field-cost-unit">
                                $
                              </Typography>
                              <Typography className="text-field-cost-unit">
                                {row?.purchase?.costPerUnit > 0
                                  ? currencyFormat(
                                      row?.purchase?.costPerUnit?.toFixed(2),
                                    )
                                  : "-"}
                              </Typography>
                            </Stack>
                          </td>
                          <td
                            className="table-book-body-field"
                            style={{ textAlign: "center" }}
                          >
                            {row?.purchase?.units}
                          </td>
                          <td className="table-book-body-field">
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                            >
                              <Typography className="text-field-cost-unit">
                                $
                              </Typography>
                              <Typography className="text-field-cost-unit">
                                {row?.purchase?.cost > 0
                                  ? currencyFormat(
                                      row?.purchase?.cost?.toFixed(2),
                                    )
                                  : "-"}
                              </Typography>
                            </Stack>
                          </td>

                          <td className="table-book-body-field">
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                            >
                              <Typography className="text-field-cost-unit">
                                $
                              </Typography>
                              <Typography className="text-field-cost-unit">
                                {row?.averageCost > 0
                                  ? currencyFormat(row?.averageCost?.toFixed(2))
                                  : "-"}
                              </Typography>
                            </Stack>
                          </td>

                          {/* <td className="table-book-body-field">
                          {" "}
                          <Stack direction="row" justifyContent="space-between">
                            <Typography className="text-field-cost-unit">
                              $
                            </Typography>
                            <Typography className="text-field-cost-unit"> 
                              {
                                row?.return?.costPerUnit > 0 ? (row?.return?.costPerUnit)?.toFixed(2) : "-"
                              }
                            </Typography>
                          </Stack>
                        </td> */}
                          <td
                            className="table-book-body-field"
                            style={{ textAlign: "center" }}
                          >
                            {row?.return?.units}
                          </td>
                          <td className="table-book-body-field">
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                            >
                              <Typography className="text-field-cost-unit">
                                $
                              </Typography>
                              <Typography className="text-field-cost-unit">
                                {row?.return?.cost > 0
                                  ? currencyFormat(
                                      row?.return?.cost?.toFixed(2),
                                    )
                                  : "-"}
                              </Typography>
                            </Stack>
                          </td>

                          {/* <td className="table-book-body-field">
                          <Stack direction="row" justifyContent="space-between">
                            <Typography className="text-field-cost-unit">
                              $
                            </Typography>
                            <Typography className="text-field-cost-unit"> 
                              {
                                row?.issues?.units > 0 ? 
                                  (parseFloat((row?.issues?.cost)?.toFixed(2))/row?.issues?.units)?.toFixed(2)
                                :
                                  "-"
                              }
                            </Typography>
                          </Stack>
                        </td> */}
                          <td
                            className="table-book-body-field"
                            style={{ textAlign: "center" }}
                          >
                            {row?.issues?.units}
                          </td>
                          <td className="table-book-body-field">
                            {" "}
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                            >
                              <Typography className="text-field-cost-unit">
                                $
                              </Typography>
                              <Typography className="text-field-cost-unit">
                                {row?.issues?.cost > 0
                                  ? currencyFormat(
                                      row?.issues?.cost?.toFixed(2),
                                    )
                                  : "-"}
                              </Typography>
                            </Stack>
                          </td>

                          {/* <td className="table-book-body-field">
                          <Stack direction="row" justifyContent="space-between">
                            <Typography className="text-field-cost-unit">
                              $
                            </Typography>
                            <Typography className="text-field-cost-unit"> 
                              {
                                row?.ending?.units > 0 && row?.ending?.cost > 0 ? 
                                  (parseFloat((row?.ending?.cost)?.toFixed(2))/row?.ending?.units)?.toFixed(2)
                                :
                                  "-"
                              }
                            </Typography>
                          </Stack>
                        </td> */}
                          <td
                            className="table-book-body-field"
                            style={{ textAlign: "center" }}
                          >
                            {row?.ending?.units}
                          </td>
                          <td className="table-book-body-field">
                            {" "}
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                            >
                              <Typography className="text-field-cost-unit">
                                $
                              </Typography>
                              <Typography className="text-field-cost-unit">
                                {row?.ending?.cost > 0
                                  ? currencyFormat(
                                      row?.ending?.cost?.toFixed(2),
                                    )
                                  : "-"}
                              </Typography>
                            </Stack>
                          </td>
                        </tr>
                      );
                    })}
                  </Fragment>
                );
              })
            )}

            <tr>
              <td className="report-table-tbody-td-total-total" colSpan={5}>
                សរុប
              </td>
              <td className="report-table-tbody-td-total-unit">
                {currencyFormat(total?.totalBeginningUnit) ?? "0.00"}
              </td>
              <td className="report-table-tbody-td-total-cost">
                <Stack
                  direction="row"
                  spacing={0}
                  justifyContent="space-between"
                >
                  <Typography>$</Typography>
                  <Typography>
                    {currencyFormat(total?.totalBeginningCost) ?? "0.00"}
                  </Typography>
                </Stack>
              </td>
              <td className="report-table-tbody-td-total-unit"></td>
              <td className="report-table-tbody-td-total-unit">
                {currencyFormat(total?.totalPurchaseUnit) ?? "0.00"}
              </td>
              <td className="report-table-tbody-td-total-cost">
                <Stack
                  direction="row"
                  spacing={0}
                  justifyContent="space-between"
                >
                  <Typography>$</Typography>
                  <Typography>
                    {currencyFormat(total?.totalPurchaseCost) ?? "0.00"}
                  </Typography>
                </Stack>
              </td>
              <td className="report-table-tbody-td-total-unit"></td>
              <td className="report-table-tbody-td-total-unit">
                {currencyFormat(total?.totalReturnUnit) ?? "0.00"}
              </td>
              <td className="report-table-tbody-td-total-cost">
                <Stack
                  direction="row"
                  spacing={0}
                  justifyContent="space-between"
                >
                  <Typography>$</Typography>
                  <Typography>
                    {currencyFormat(total?.totalReturnCost) ?? "0.00"}
                  </Typography>
                </Stack>
              </td>
              <td className="report-table-tbody-td-total-unit">
                {currencyFormat(total?.totalIssueUnit) ?? "0.00"}
              </td>
              <td className="report-table-tbody-td-total-cost">
                <Stack
                  direction="row"
                  spacing={0}
                  justifyContent="space-between"
                >
                  <Typography>$</Typography>
                  <Typography>
                    {currencyFormat(total?.totalIssueCost) ?? "0.00"}
                  </Typography>
                </Stack>
              </td>
              <td className="report-table-tbody-td-total-unit">
                {currencyFormat(total?.totalEndUnit) ?? "0.00"}
              </td>
              <td className="report-table-tbody-td-total-cost">
                <Stack
                  direction="row"
                  spacing={0}
                  justifyContent="space-between"
                >
                  <Typography>$</Typography>
                  <Typography>
                    {currencyFormat(total?.totalEndCost) ?? "0.00"}
                  </Typography>
                </Stack>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
